import * as actionTypes from '../actionType';

const defalutState = {
  studentListObject: {}
}
export default {
  studentListObject(state = defalutState.studentListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_STUDENTLIST:
        return payload;
      default:
    }

    return state;
  }
}

